<script>
    import { mapGetters } from "vuex";
    import { lazyLoad } from "@/utils";
    import { catalogApplication } from "@picooc/textApplication";
    import CatalogCardProduct from "@picooc/components/CatalogCardProduct";

    export default {
        name: "ApplicationCatalog",
        components: {
            CatalogCardProduct,
        },
        props: {
            products: Array,
        },
        computed: {
            ...mapGetters("Root", ["productsInCartIds"]),
            bluetoothProducts() {
                return this.products.filter((product) => {
                    return catalogApplication.bluetooth.includes(product.id);
                });
            },
            wifiProducts() {
                return this.products.filter((product) => {
                    return catalogApplication.wifi.includes(product.id);
                });
            },
        },
        watch: {
            products: {
                handler(products) {
                    if (products.length) {
                        this.$nextTick(() => {
                            lazyLoad();
                        });
                    }
                },
                immediate: true,
            },
        },
    };
</script>

<template>
    <section class="application-catalog">
        <header class="application-catalog__header">
            <h2 class="application-catalog__title page-title">
                Одно приложение для всех устройств
            </h2>
            <div class="application-catalog__text">
                Пользуйтесь всеми продуктами Picooc в&nbsp;одном удобном приложении.
                <span>Количество одновременно добавленных устройств не&nbsp;ограничено.</span>
            </div>
        </header>

        <div class="application-catalog__products">
            <div
                class="application-catalog__product"
                v-for="product in bluetoothProducts"
                :key="product.id"
            >
                <catalog-card-product
                    :product="product"
                    type="bluetooth"
                    ratio="square"
                    :in-cart-list="productsInCartIds"
                ></catalog-card-product>
            </div>
            <div
                class="application-catalog__product"
                v-for="product in wifiProducts"
                :key="product.id"
            >
                <catalog-card-product
                    :product="product"
                    type="wifi"
                    ratio="square"
                    :in-cart-list="productsInCartIds"
                ></catalog-card-product>
            </div>
        </div>
    </section>
</template>

<style lang="scss">
    .application-catalog {
        padding-bottom: 20px;
        @include bp($bp-desktop-sm) {
            padding-bottom: 0;
        }
    }

    .application-catalog__header {
        padding: 0 16px;
        @include bp($bp-desktop-sm) {
            text-align: center;
        }
    }

    .application-catalog__title {
        margin-bottom: 16px;
        @include bp($bp-desktop-sm) {
            margin-bottom: 24px;
        }
    }

    .application-catalog__text {
        margin-bottom: 28px;
        color: #353535;
        font-size: 14px;
        line-height: 28px;
        @include bp($bp-desktop-sm) {
            max-width: 800px;
            margin: 0 auto 32px;
            color: #474747;
            font-size: 16px;
            line-height: 32px;
            span {
                display: block;
            }
        }
    }

    .application-catalog__products {
        display: flex;
        flex-wrap: wrap;
        margin: 0 -4px -8px;
        @include bp($bp-desktop-md) {
            margin: 0 -12px -24px;
        }
    }

    .application-catalog__product {
        flex-basis: calc(100% / 2);
        max-width: calc(100% / 2);
        padding: 0 4px 8px;
        @include bp($bp-desktop-md) {
            flex-basis: calc(100% / 3);
            max-width: calc(100% / 3);
            padding: 0 12px 24px;
        }
    }
</style>
